<template>
  <div class="product-card">
    <div
      v-if="qualifications[product.sku] && qualifications[product.sku].quantity > 0"
    >
      <div class="available-qty">
        <div class="num-available" v-if="qualifications[product.sku]">
          <div class="before-block"></div>
          <div class="middle-block">
            {{ qualifications[product.sku].quantity }}
          </div>
          <div class="after-block"></div>
        </div>
        {{ tdc.tdc_reservedForYou }}
      </div>
      <ns-product-basic
        class="hide-sku"
        no-variant-selector
        :sku="getDisplaySku(product)"
        hide-favorites
        no-action
        hide-exclusive-icon
        fallback-src="/etc/designs/hello/packaged/img/product-basic__fallback-image.svg"
      />
      <div
        class="action-container"
      >
        <div
          v-if="Object.keys(product.variants).length > 0"
          class="variant-container"
        >
          <NsSlottedDropdown
            @select="handleVariantSelection"
            :placeholder="tdc.tdc_variantDropdownLabel"
            :selected="variantSelection"
            :showCustomSelectedItem="!isTouchDevice"
            id="variantDropdown"
          >
            <div
              v-for="(variant, key, index) in product.variants"
              :key="key"
              :value="key"
              :data-value="index"
              class="variantDropdownItems"
            >
              <div
                v-if="!!variant.shade"
                class="shade"
                :style="{
                  ...shadeCSS,
                  backgroundColor: variant.shade,
                }"
              ></div>
              <p>{{ variant.variantDropdownLabel }}</p>
            </div>
            <template v-slot:custom>
              <div name="custom" class="customVariantSlot" >
                <div
                  class="shade"
                  :style="{
                    ...shadeCSS,
                    backgroundColor: getVariant(product) ? getVariant(product).shade : null
                  }"
                ></div>
                <p>{{ getVariant(product) ? getVariant(product).variantDropdownLabel : null }}</p>
              </div>
            </template>
          </NsSlottedDropdown>
        </div>
        <div class="quantity-container">
          <ns-quantity-selector
            :id="'mainQuantitySelector_' + product.sku"
            v-if="qualifications[product.sku]"
            :quantity="quantitySelection"
            @quantity-changed="quantitySelection = $event.detail.value"
            :max="qualifications[product.sku].quantity"
            :open-modal="isTouchDevice"
          />
          <span style="margin-left: 5px;"><strong v-if="qualifications[product.sku]" :id="'mainItemQuantity_' + product.sku">/ {{ qualifications[product.sku].quantity }}</strong></span>
        </div>
        <event-button
          :qualification="qualifications[product.sku]"
          :product="Object.keys(product.variants).length > 0 ? getVariant(product) : product"
          @click="addSkuToCart"
        />
      </div>
    </div>
    <div v-else-if="qualifications[product.sku] && getQualificationAddOnQuantity(product) > 0">
      <AddOns
        :product="product"
        :qualification="qualifications[product.sku]"
        :parentProduct="true"
      />
    </div>
    <AddOns
      v-if="
        qualifications[product.sku]&&
        qualifications[product.sku].addOns &&
        !qualifications[product.sku].addOns.errorMessage &&
        Object.keys(qualifications[product.sku].addOns).length > 0 &&
        getQualificationAddOnQuantity(product) > 0"
      :product="product"
      :qualification="qualifications[product.sku]"
    />
  </div>
</template>

<script>
import {
  events,
  RunConfigService,
  util,
} from '@nuskin/ns-util'

import { NsSlottedDropdown } from '@nuskin/design-components'
import EventButton from '../events/EventButton.vue'

import AddOns from './AddOns.vue'

export default {
  components: {
    AddOns,
    EventButton,
    NsSlottedDropdown,
  },
  props: {
    product: Object,
    qualifications: Array,
    tdc: Object,
  },
  data() {
    return {
      country: RunConfigService.getRunConfig().country,
      isTouchDevice: util.MobileUtils.isMobileLike(),
      language: RunConfigService.getRunConfig().language,
      variantSelection: null,
      quantitySelection: 1,
      shadeCSS: {
        borderRadius: '50%',
        height: '20px',
        marginRight: '10px',
        width: '20px'
      }
    }
  },
  methods: {
    getDisplaySku(product) {
      if (this.variantSelection !== null) {
        return Object.keys(product.variants)[this.variantSelection]
      }
      return product.sku
    },
    getVariant(product) {
      if (this.variantSelection === null) {
        return
      }
      const variantSKU = Object.keys(product.variants)[this.variantSelection]
      const variant = product.variants[variantSKU]
      return variant
    },
    handleVariantSelection(newValue) {
      this.variantSelection = newValue
    },
    addSkuToCart() {
      const sku = this.getSku()
      const options = {
        cntryCd: this.country,
        language: this.language,
        userId: window.user ? window.user.id : null,
        qty: this.quantitySelection,
        region: null,
        isAdr: false,
        sku,
      }

      aem.CartService.addSkuToCart(options).catch((err) => {
        if (err instanceof aem.NsNotQualifiedException) {
          events.publish(events.shop.SHOW_EXCLUSIVE_OFFER_DETAILS, {
            sku,
          })
        }
      })
    },
    getSku() {
      if (this.variantSelection === null) {
        return this.product.sku
      }
      const variant = this.getVariant(this.product)
      return variant.sku
    },
    getQualificationAddOnQuantity(product) {
      const qualification = this.qualifications[product.sku]
      const hasAddons = qualification.addOns && Object.keys(qualification.addOns).length > 0
      let addOnQuantities = 0
      if (hasAddons) {
        Object.values(qualification.addOns).forEach(addOn => {
          addOnQuantities += addOn.quantity
        })
      }
      return addOnQuantities
    },
  }
}
</script>

<style lang="scss">
#variantDropdown {
  margin-right: 5px;
  width: 100%;
  .dropdown-area {
    .current-selection {
      height: 25px;
      min-height: 50px;
      border: 1px solid #63666A;
      display: flex;
      justify-content: space-between;
      .selected-item {
        display: initial;
      }
    }
  }
  .variantDropdownItems {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
  }
}

.customVariantSlot {
  display: flex;
  justify-content: flex-start;
}
</style>
